// extracted by mini-css-extract-plugin
export default {"container":"Body_container__pnchc","wrapper":"Body_wrapper__N-5N3","heading":"Body_heading__WFGxb","subHeading":"Body_subHeading__lq9zA","grid":"Body_grid__13YqW"};